module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="phx-center phx-proto-resizable">\r\n</div>\r\n';
}
return __p;
};
